import React from 'react'

const Psudo = () => {
    return (
        <div className='container'>
            <div classSymbol='container'>
                <h2>What is PseudoCode?</h2>
            <p>In computer science, pseudocode is a plain language Example of 
                the steps in an algorithm or another system. Pseudocode often uses 
                structural conventions of a normal programming language, but is intended 
                for human reading rather than machine reading. It typically omits details
                 that are essential for machine understanding of the algorithm, such as 
                 variable declarations and language-specific code. The programming language
                  is augmented with natural language Example details, where convenient, or
                   with compact mathematical notation. The purpose of using pseudocode is that it 
                   is easier for people to understand than conventional programming language code, 
                   and that it is an efficient and environment-independent Example of the key 
                   principles of an algorithm. It is commonly used in textbooks and scientific 
                   publications to document algorithms and in planning of software and other 
                   algorithms.</p>
        </div>
        <table>
  <caption>Common Symbols</caption>
  <thead>
    <tr>
      <th scope="col">Type of operation</th>
      <th scope="col">Symbol</th>
      <th scope="col">Example</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td data-label="Type of operation">Assignment</td>
      <td data-label="Symbol"> ← or := </td>
      <td data-label="Example">c ← 2πr, c := 2πr</td>
    </tr>
    <tr>
      <td scope="row" data-label="Type of operation">Comparison </td>
      <td data-label="Symbol"> =, ≠,&#5172;, &#5176; ≤, ≥</td>
      <td data-label="Example"> </td>
    </tr>
    <tr>
      <td scope="row" data-label="Type of operation">Arithmetic</td>
      <td data-label="Symbol">+, −, ×, /, mod</td>
      <td data-label="Example"> </td>
    </tr>
    <tr>
      <td scope="row" data-label="Type of operation">Floor/ceiling</td>
      <td data-label="Symbol">⌊, ⌋, ⌈, ⌉</td>
      <td data-label="Example">a ← ⌊b⌋ + ⌈c⌉</td>
    </tr>
    <tr>
      <td scope="row" data-label="Type of operation">Logical</td>
      <td data-label="Symbol"> and, or</td>
      <td data-label="Example"></td>
    </tr>
    <tr>
      <td scope="row" data-label="Type of operation">Sums, products</td>
      <td data-label="Symbol">Σ Π	</td>
      <td data-label="Example">	h ← Σa∈A 1/a</td>
    </tr>
   
  </tbody>
</table>
<div className='container'>
  <h3>for Example:</h3> <br />
  <p>Write a PseudoCode to find greatest of 3 number</p> <br />
  <p>First we will the value of our three number</p><br />
  <p>Let the a,b and c  as 5, 10 and 15 respectively</p><br />
 <p> At first condition program will check a ≥ b and a ≥ c,as we can see that this condition will not satisfy</p> <br />
 <p>Now it will check second condition b ≥ a and b ≥ c,this will also get failed</p> <br />
 <p>so now we have 3 condition in which two get failed there last condition will be printed </p> <br />
  <h2 className='text-center'>Pseudocode</h2>
      <pre>
          read a,b,c <br />
             if (a ≥ b and a ≥ c) then <br />
             print a <br />
             exit <br />
      end if (b ≥ a and b ≥ c ) then <br />
        print b <br />
        exit <br />
      end if  <br />
      print C <br />
      </pre>
 
  </div>
  
        </div>
    )
}

export default Psudo
